/**
 * 하단 Import 진행 박스(Global upload toast)의 click action 우선순위 판정.
 *
 * STUDIO-ASSET-003 정본:
 * - Home 등 `.viewr` 외 화면에서 변환 결과가 준비되면 `Tap to import to Space.`를 표시하고,
 *   클릭하면 대기 패널을 제거하고 원래 `.viewr`와 target Space를 열어 로드를 계속합니다.
 * - `Import to Space` 대기의 100% 표시는 정적 준비 완료 표현이며 진행 중이 아닙니다.
 * - 20초 장기 처리 문구/상세는 진행 중 단계에만 적용됩니다.
 *
 * 따라서 우선순위는 conversion report → restore(import to space) → 장기 처리 상세입니다.
 */
export type UploadToastClickAction =
  | "conversion_report"
  | "restore_import_to_space"
  | "long_running_progress"
  | "none";

export const resolveUploadToastClickAction = (input: {
  hasConversionReport: boolean;
  clickActionReady: boolean;
  hasLongRunningProgress: boolean;
}): UploadToastClickAction => {
  if (input.hasConversionReport) return "conversion_report";
  if (input.clickActionReady) return "restore_import_to_space";
  if (input.hasLongRunningProgress) return "long_running_progress";
  return "none";
};
